import axios from '../../../commons/gdprcontrol-axios'

const state = {
  users: [],
  allUsers: []
}

const getters = {
  getUserList: state => state.users,
  getAllUsers: state => state.allUsers
}

const actions = {
  fetchUserList: async ({ commit, rootGetters }) => {
    let URL = '/api/users/'

    let ret = []
    const searchString = rootGetters['searchBox/getSearchString']
    if (searchString !== '') { ret.push(`q=${searchString}`) }

    const pageNum = rootGetters['pagination/getCurrentPage']
    if (pageNum > 1) { ret.push(`page=${pageNum}`) }

    URL += (ret.length ? '?' : '') + ret.join('&')

    return axios.get(URL)
      .then(response => {
        commit('storeUsers', response.data.data)
        commit('pagination/setObjectCount', response.data.total, {root: true})
      })
      .catch(error => {
        alert('Hiba a felhasználók letöltése közben')
        throw error
      })
  },

  fetchAllUsers: async ({ commit }) => {
    return axios.get('/api/users/all/')
      .then(response => {
        commit('storeAllUsers', response.data)
      })
      .catch(error => {
        alert('Hiba a felhasználók letöltése közben')
        throw error
      })
  }
}

const mutations = {
  storeUsers (state, users) {
    state.users = users
  },

  storeAllUsers (state, allUsers) {
    state.allUsers = allUsers
  }
}

export default { state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/users/list.js